import BookingsSerializer from './base';

export default class Allocation extends BookingsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      available: 0,
      blocked: false,
      booked: 0,
      reservations: [],
      reserved: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
